import React from 'react';
type Tone = 'mist' | 'light' | 'aqua' | 'amber' | 'demo';
const tones: Record<Tone, string> = {
  mist: 'bg-mist text-primary',
  light: 'bg-white/15 text-white',
  aqua: 'bg-secondary/20 text-secondary border border-secondary/30',
  amber: 'bg-[#FEF3C7] text-[#92400E]',
  demo: 'bg-secondary/15 text-secondary border border-secondary/30'
};
type PillProps = {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
};
export function Pill({
  tone = 'mist',
  className = '',
  children
}: PillProps) {
  return <span className={`inline-flex items-center gap-2 rounded-pill px-4 py-[6px] font-sans text-[13px] font-medium ${tones[tone]} ${className}`} data-id="element-332" data-mp="14nxonfr2nkeb">
      {children}
    </span>;
}